'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="es">
      <body>
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Rubik, system-ui, sans-serif',
          padding: '1rem',
        }}>
          <div style={{ textAlign: 'center', maxWidth: '28rem' }}>
            <h1 style={{ fontSize: '2rem', fontWeight: 600, marginBottom: '1rem' }}>
              Algo salió mal
            </h1>
            <p style={{ color: '#6b7280', marginBottom: '2rem' }}>
              Ocurrió un error inesperado. Intentá de nuevo o volvé al inicio.
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button
                onClick={reset}
                style={{
                  padding: '0.75rem 1.5rem',
                  borderRadius: '9999px',
                  border: '1px solid #d1d5db',
                  background: 'transparent',
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  fontSize: '1rem',
                }}
              >
                Reintentar
              </button>
              <a
                href="/"
                style={{
                  padding: '0.75rem 1.5rem',
                  borderRadius: '9999px',
                  background: '#FF5807',
                  color: '#fff',
                  textDecoration: 'none',
                  fontSize: '1rem',
                }}
              >
                Ir al inicio
              </a>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
